/* eslint-disable react/button-has-type */
import { nanoid } from 'nanoid';
import { useState } from 'react';
import '../../css/pagination.css';
import BaseUrls from '../../utils/baseUrls';

export type PaginationDependency = {
    totalItems:number
    renderPagination:boolean
    itemsPerPage:number
    getPage:(offset:number, limit:number)=>Promise<boolean>
    pageLimit:number
}
function Paginate({
  totalItems, itemsPerPage, renderPagination, getPage, pageLimit,
}:PaginationDependency) {
  const pages = Math.ceil(totalItems / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageNavigationStatus, setPageNavigationStatus] = useState<boolean>(true);
  function goToNextPage() {
    if (pageNavigationStatus && (currentPage + 1) <= pages) {
      setCurrentPage(currentPage + 1);

      setOffset(offset + itemsPerPage);
      setPageNavigationStatus(false);
      getPage(offset + itemsPerPage, itemsPerPage).then(() => setPageNavigationStatus(true));
    }
  }

  function goToPreviousPage() {
    if (pageNavigationStatus && (currentPage - 1) >= 1) {
      setCurrentPage(currentPage - 1);
      setOffset(offset - itemsPerPage);
      setPageNavigationStatus(false);
      getPage(offset - itemsPerPage, itemsPerPage).then(() => setPageNavigationStatus(true));
    }
  }

  function changePage(event:any) {
    const pageNumber = Number(event.target.innerText);
    const itemOffset = (pageNumber - 1) * itemsPerPage;
    if (pageNavigationStatus && itemOffset < totalItems) {
      setCurrentPage(pageNumber);
      setOffset(itemOffset);
      setPageNavigationStatus(false);
      getPage(itemOffset, itemsPerPage).then(() => setPageNavigationStatus(true));
    }
  }

  const getPaginationGroup = () => {
    const currentPageLimit = pageLimit > pages ? pages : pageLimit;
    const start = Math.floor((currentPage - 1) / currentPageLimit) * (currentPageLimit);
    return new Array(currentPageLimit).fill(0).map((_, idx) => start + idx + 1);
  };

  return (
    <>
    {renderPagination
        && (
<div className="pagination mt-3">
      {/* previous button */}
            <button
onClick={goToPreviousPage}
className={`${BaseUrls.getkey()}-prev ${currentPage === 1 ? 'disabled' : ''}`}
            >
        prev
            </button>

      {/* show page numbers */}
      {getPaginationGroup().map((item) => (
        <button
          key={nanoid()}
          className={`${BaseUrls.getkey()}-paginationItem ${currentPage === item ? 'active' : null}`}
          onClick={changePage}
        >
          <span>{item}</span>
        </button>
      ))}

      {/* next button */}
      <button
        onClick={goToNextPage}
        className={`${BaseUrls.getkey()}-next ${currentPage === pages ? 'disabled' : ''}`}
      >
        next
      </button>
</div>
        )}
    </>

  );
}
export default Paginate;